import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

/**
 * Buscar XML individual
 * GET /file_xml/:accesskey
 */
export async function fetchFileXml(accessKey) {
  const url = new URL(`/file_xml/${accessKey}`, API_BASE_URL);

  const response = await fetch(url.toString());
  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar XML"));
  }

  return data;
}

/**
 * Buscar vários XMLs
 * POST /file_xml
 */
export async function fetchFileXmls(accessKeys) {
  const url = new URL(`/file_xml`, API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      accesskeys: accessKeys,
    }),
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar XMLs"));
  }

  return data;
}

export async function downloadDanfePdfBatch(accessKeys) {
  const url = new URL("/danfe/pdf-batch", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      accesskeys: accessKeys,
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("Erro backend /danfe/pdf-batch:", text);

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(text || "Resposta inválida do servidor");
    }

    throw new Error(resolveApiMessage(data, "Erro ao gerar PDFs das DANFEs"));
  }

  return await response.blob();
}

export async function downloadXmlBatch(accessKeys) {
  const url = new URL("/xml/batch", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      accesskeys: accessKeys,
    }),
  });

  if (!response.ok) {
    const text = await response.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(text || "Resposta inválida do servidor");
    }

    throw new Error(resolveApiMessage(data, "Erro ao gerar XMLs"));
  }

  return await response.blob();
}
